export enum AddAssetAction {
	Blank = 0,
	Template = 1,
	Upload = 2,
	AddLink = 3,
	AddYoutubeLink = 4,
	AddVimeoLink = 5,
	AddSoundCloudLink = 6,
	AddDocUpload = 7,
	ShareAsset = 8,
	CreateCustomTemplate = 9,
	CreateFromPremiumTemplate = 10,
	Duplicate = 11,
	PremiumSermon = 12,
	PremiumSermonSeries = 13,
	Genius = 14,
	Analyzer = 15,
	HearItNow = 16,
	Folder = 17,
	Series = 18,
	ImportSermonFromSC = 19,
}